export default "__VITE_ASSET__29f31f52__"